var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSuccessGreen = function SvgIconSuccessGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#429D15",
    d: "M17 .336C7.817.336.333 7.819.333 17.003c0 9.183 7.484 16.666 16.667 16.666s16.667-7.483 16.667-16.666S26.183.336 17 .336m7.967 12.833-9.45 9.45a1.25 1.25 0 0 1-1.767 0l-4.716-4.716a1.26 1.26 0 0 1 0-1.767 1.26 1.26 0 0 1 1.766 0l3.833 3.833 8.567-8.566a1.257 1.257 0 0 1 1.767 0 1.257 1.257 0 0 1 0 1.766"
  })));
};
export default SvgIconSuccessGreen;